import * as React from 'react';
import cn from 'classnames';
import MediaQuery from 'react-responsive';
import { useTranslation } from 'react-i18next';

import { Location } from '../../../../../../../LocationAutocomplete/types';
import { LocationType } from '../../../../../../../types';
import { MOBILE_MIN_WIDTH } from '../../../../../../../utils';
import { ConfigContext } from '../../../../../../../context';
import { useTheme } from '../../../../../../../theme';
import { getDirectionAttribute } from './utils';

export interface Props {
	className?: string;
	isLoading: boolean;
	isOpen: boolean;
	location: Location;
	inputValue: string;
	type: LocationType;
	withMultiCity?: boolean;
	segmentId?: number;
	onClick?: (event: any) => void;
}

const Value: React.FunctionComponent<Props> = ({
	className,
	isOpen,
	isLoading,
	location,
	inputValue,
	type,
	withMultiCity,
	segmentId
}) => {
	const { Value: css } = useTheme('SearchForm');
	const { t } = useTranslation('SearchForm');

	const alternative = React.useContext(ConfigContext).SearchForm.mobileFormType !== 'common';
	const proMode = React.useContext(ConfigContext).SearchForm.proMode;

	const isDeparture = type === LocationType.Departure;

	const renderFocusedWrapper = () => {
		return (
			<div
				className={cn(css.wrapper, css.wrapper_focused, className, {
					[css.wrapper_padded]: isLoading
				})}
			>
				{!inputValue && (
					<span className={css.placeholder}>
						{t(isDeparture ? 'From, enter city or country' : 'To, enter city or country')}
					</span>
				)}
				{isLoading && <span className={css.loader} />}
			</div>
		);
	};

	const renderValue = () => {
		return (
			<div
				className={cn(css.wrapper, className, {
					[css.wrapper_alternative]: alternative,
					[css.withMultiCity]: withMultiCity,
					[css.advanced]: proMode
				})}
			>
				<span className={css.value} {...getDirectionAttribute(isDeparture, 'city')} data-segment-id={segmentId}>
					{location.name}
				</span>
				<span className={css.code} {...getDirectionAttribute(isDeparture, 'iata')} data-segment-id={segmentId}>
					{location.iata}
				</span>
			</div>
		);
	};

	return (
		<>
			<MediaQuery minWidth={MOBILE_MIN_WIDTH}>
				{location && renderValue()}
				{isOpen && renderFocusedWrapper()}
			</MediaQuery>

			<MediaQuery maxWidth={MOBILE_MIN_WIDTH}>{location && renderValue()}</MediaQuery>
		</>
	);
};

export default Value;
